import { CREATE_DEPOSIT_SESSION_MUTATION } from './GraphQlQuery/CasinoGraphqlQueries';
import type { CreateDepositSessionInput, DepositSessionResult } from './Type/CasinoTypes';
import { pokerGraphqlRequest } from '../Utils/PokerGraphqlClient';

export const buildDepositReturnUrl = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;

  try {
    return new URL('/cashier', window.location.origin).toString();
  } catch {
    return undefined;
  }
};

export const createDepositSession = async (args: {
  input?: CreateDepositSessionInput;
  signal?: AbortSignal;
}): Promise<DepositSessionResult> => {
  const res = await pokerGraphqlRequest<
    { createDepositSession: DepositSessionResult },
    { input?: CreateDepositSessionInput }
  >({
    query: CREATE_DEPOSIT_SESSION_MUTATION,
    variables: args.input ? { input: args.input } : undefined,
    signal: args.signal,
  });

  return res.createDepositSession;
};
